<template>
  <div class="exact-modal" :class="`step-${currentStep}`">
    <p class="exact-modal-header">{{ $t('dashboard.expandDomain.title') }}</p>
    <div ref="scrollArea" class="exact-modal-body">
      <setting-exact-basic
        v-if="currentStep === 1"
        :report-name="reportName"
        @update:report-name="setReportName"
      />
      <setting-exact-detail
        v-else
        :is-toggle-on="exactDetailForm.isToggleOn"
        :custom-parameters="exactDetailForm.customParameters"
        @update:is-toggle-on="updateExactDetailField('isToggleOn', $event)"
        @update:custom-parameters="updateExactDetailField('customParameters', $event)"
      />
    </div>
    <div class="exact-modal-footer" :class="{'has-scroll': hasScroll}">
      <ui-checkbox v-if="currentStep === 1" :value="checkConfirm" @input="onChangeCheckboxValue">
        {{ $t('dashboard.expandDomain.confirm') }}
      </ui-checkbox>
      <button
        v-if="currentStep === 2"
        class="exact-modal-footer-back"
        @click="goToStep(1)"
      >
        <i class="icon icon--arrow-left-black size-12"></i>
        <span>{{ $t('common.back') }}</span>
      </button>
      <div>
        <button
          class="btf-button outline"
          @click="$emit('close')"
        >
          {{ $t('common.cancel') }}
        </button>
        <button
          class="btf-button primary"
          :class="{ disabled: isConfirmDisabled }"
          @click="onClickConfirmButton"
        >
          {{ currentStep === 1 ? $t('common.next') : $t('common.confirm') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import UiCheckbox from '@/components/ui/UiCheckbox.vue'
import SettingExactBasic from '@/components/dashboard/SettingExactBasic.vue'
import SettingExactDetail from '@/components/dashboard/SettingExactDetail.vue'

export default {
  name: 'SettingExact',
  components: { UiCheckbox, SettingExactBasic, SettingExactDetail },
  props: {},
  data () {
    return {
      currentStep: 1,
      reportName: '',
      checkConfirm: false,
      hasScroll: false,
      exactDetailForm: {
        isToggleOn: true,
        customParameters: []
      }
    }
  },
  computed: {
    isConfirmDisabled () {
      if (this.currentStep === 1) {
        return !this.checkConfirm || this.reportName.length === 0
      }

      return false
    }
  },
  mounted () {
    this.checkScroll()
    window.addEventListener('resize', this.checkScroll)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkScroll)
  },
  methods: {
    setReportName (value) {
      this.reportName = value
    },
    onChangeCheckboxValue (value) {
      this.checkConfirm = value
    },
    updateExactDetailField (field, value) {
      this.exactDetailForm = {
        ...this.exactDetailForm,
        [field]: value
      }
    },
    onClickConfirmButton () {
      if (this.isConfirmDisabled) return

      if (this.currentStep === 1) {
        this.goToStep(2)
        return
      }

      this.setExactReport()
    },
    goToStep (step) {
      this.currentStep = step
      this.checkScroll()
      this.$nextTick(() => {
        const scrollArea = this.$refs.scrollArea
        if (scrollArea) {
          scrollArea.scrollTop = 0
        }
      })
    },
    setExactReport () {
      this.$emit('submit', {
        reportName: this.reportName,
        isToggleOn: this.exactDetailForm.isToggleOn,
        customParameters: this.exactDetailForm.customParameters
      })
    },
    checkScroll () {
      this.$nextTick(() => {
        const scrollArea = this.$refs.scrollArea
        this.hasScroll = scrollArea.scrollHeight > scrollArea.clientHeight
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.exact-modal {
  display: flex;
  flex-direction: column;
  max-height: calc(100% - 144px);
  min-height: 360px;
  width: 530px;
  padding: 28px 0 24px;
  border-radius: 14px;
  background-color: #fff;
  font-weight: 400;
  color: #2f2f2f;
  box-sizing: border-box;

  &.step-2 {
    width: 600px;
  }

  &-header {
    position: relative;
    min-height: 27px;
    padding: 0 28px;
    font-size: 15px;
    font-weight: 500;
    color: #2f2f2f;
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 12px;
      left: 0;
      bottom: 0;
      z-index: 100;
      background: linear-gradient(0deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%);
      transform: translateY(100%);
    }
  }
  &-body {
    flex: 1;
    padding: 19px 28px 0;
    overflow-y: auto;
  }
  &-footer {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding: 24px 28px 0;

    & /deep/ .ui_checkbox {
      margin-left: 0;
      .text {
        color: #2f2f2f;
        font-size: 13px;
        font-weight: 400;
      }
    }
    &.has-scroll {
      &:before {
        content: '';
        position: absolute;
        width: 100%;
        height: 12px;
        left: 0;
        bottom: 100%;
        z-index: 100;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.06) 100%);
      }
    }

    &-back {
      @include flexXYcenter;
      position: absolute;
      left: 24px;
      bottom: 5px;
      gap: 4px;
      height: 28px;
      padding-left: 8px;
      padding-right: 10px;
      color: #444;
      font-size: 12px;
      font-weight: 600;
      .icon {
        transform: translateY(-0.5px);
      }
    }
  }
}
</style>
